<script>
import _ from 'lodash'
// eslint-disable-next-line import/no-named-default
import { default as enums, EnumType } from '@/lib/enums'
import { QSelect } from 'quasar'
import FieldIconMixin from './FieldIconMixin.js'
import FieldProxyMixin from './FieldProxyMixin.js'
import FieldSelectMixin from './FieldSelectMixin.js'
import FieldDenseMixin from './FieldDenseMixin'

export default {
  mixins: [FieldIconMixin, FieldProxyMixin, FieldSelectMixin, FieldDenseMixin],
  props: {
    enum: {
      required: true,
      type: [String, EnumType]
    },
    inline: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // FieldSelectMixin中处理用户过滤关键字后设置到this.selectOptions
      selectOptions: null
    }
  },
  computed: {
    enumType () {
      return _.isString(this.enum) ? enums[this.enum] : this.enum
    },
    // override PrependIconMixin
    computedPrependIcon () {
      return this.prependIcon ?? this.enumType.icon
    },
    // override FieldSelectMixin
    allOptions () {
      return this.enumType.items
    }
  },
  created () {
    this.selectOptions = this.validOptions
  },
  render (createElement) {
    const useInput = this.useInput ?? (this.validOptions.length > 7)
    return createElement(QSelect, {
      ref: 'input',
      props: {
        ...this.$props,
        dense: this.computedDense,
        useInput: useInput,
        hideSelected: this.hideSelected ?? useInput,
        fillInput: this.fillInput ?? useInput,
        options: this.selectOptions,
        label: this.label ?? this.enumType.label,
        useChips: this.multiple,
        disable: false,
        readonly: this.disable || this.readonly
      },
      attrs: { ...this.$attrs },
      on: Object.assign({
        filter: (val, update) => {
          this.onFilterOptions(val, update)
        }
      }, this.$listeners),
      scopedSlots: Object.assign({
        prepend: this.slotPrependIcon(createElement),
        option: this.slotOption(createElement),
        'selected-item': this.slotSelectedItem(createElement)
      }, this.$scopedSlots)
    })
  }
}
</script>
